import type { ExploreContentResponsePageAllOf } from './exploreContentResponsePageAllOf';
import type { ExploreContentResponsePageAllOfThree } from './exploreContentResponsePageAllOfThree';

export type ExploreContentResponsePage = ExploreContentResponsePageAllOf & ExploreContentResponsePageAllOfThree;
